import { render, staticRenderFns } from "./OrderGroupingForm.vue?vue&type=template&id=05b17d69&scoped=true&"
import script from "./OrderGroupingForm.vue?vue&type=script&lang=js&"
export * from "./OrderGroupingForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderGroupingForm.vue?vue&type=style&index=0&id=05b17d69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b17d69",
  null
  
)

export default component.exports